import { api } from 'app/api';

/**
 * @param {{ hspId:string, usrId:string, hsptlzRsvNo:string }} params
 * @description I-14 입원 동의서 환자 동의 정보 화면
 * @returns
 */
export const getHsptlzFormCcrcInfo = async (params) => {
  return await api.get(`/dfd/api/if/web/v1/hsptlz-form-sign-info-content-view`, {
    params,
  });
};
